import { TitlebarComponent } from '../../../shared/titlebar/titlebar.component';
import { EVENTO, TYPEPAGE } from '../../../shared/common/constant.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UserNewComponent } from './new/user-new.component';
import { UserEditComponent } from './edit/user-edit.component';
import { UserViewComponent } from './view/user-view.component';

@Component({
  //moduleId: module.id,
  selector: 'app-user',
  templateUrl: 'user.component.html'
})

export class UserComponent implements OnInit {
  @ViewChild(UserNewComponent) userNewComponent: UserNewComponent;
  @ViewChild(UserEditComponent) userEditComponent: UserEditComponent;
  @ViewChild(UserViewComponent) userViewComponent: UserViewComponent;
  @ViewChild(TitlebarComponent) titlebarComponent: TitlebarComponent;

  evento: EVENTO;
  modulo: string;
  mantenimiento: string;
  mantenimientoDocumento: string;
  titleGeneral: string;
  titleInsertar: string;
  titleEditar: string;
  titleConsultar: string;
  msgEditar: string;
  msgEditarDocumento: string;
  data: any;
  landingPage: string;

  constructor() {
  }

  ngOnInit() {
    this.landingPage = "/landingAccess";
    this.evento = EVENTO.listar;
    this.modulo = "Seguridad";
    this.mantenimiento = "Usuario";
    this.mantenimientoDocumento = "Documento"
    this.titleGeneral = this.modulo + ": " + this.mantenimiento;
    this.msgEditar = "EDITAR " + this.mantenimiento.toUpperCase();
    this.msgEditarDocumento = "EDITAR " + this.mantenimientoDocumento.toUpperCase();
    this.data = [];
    this.setTitleListar();
  }

  setTitleListar() {
    this.titlebarComponent.iClose = true;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: "" }];
    this.titlebarComponent.eventClose = this.landingPage;
  }

  setTitleInsertar(data: any) {
    this.titleInsertar = "Nuevo Usuario";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.listar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleInsertar, event: "" }];
  }

  setTitleEditar(data: any) {
    this.titleEditar = this.mantenimiento + ": " + " (Cod. " + data.user.ID + ")";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.consultar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleEditar, event: "" }];
  }

  setTitleConsultar(data: any) {
    this.titleConsultar = this.mantenimiento + ":  " + data.user.Name + "  (Cod. " + data.user.ID + ")";
    this.titlebarComponent.iBack = true;
    this.titlebarComponent.iEdit = true;
    this.titlebarComponent.eventBack = EVENTO.listar;
    this.titlebarComponent.eventEdit = EVENTO.editar;
    this.titlebarComponent.msgEditar = this.msgEditar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleConsultar, event: "" }];
  }
  //Documento
  setTitleInsertarDocumento(data: any) {
    this.titleInsertar = "Nuevo Documento";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.listar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleInsertar, event: "" }];
  }

  setTitleConsultarDocumento(data: any) {
    this.titleConsultar = this.mantenimiento + ":  " + data.user.Name + "  (Cod. " + data.user.ID + ")";
    this.titlebarComponent.iBack = true;
    this.titlebarComponent.iEdit = true;
    this.titlebarComponent.eventBack = EVENTO.consultar;
    this.titlebarComponent.eventEdit = EVENTO.editarDocumento;
    this.titlebarComponent.msgEditar = this.msgEditarDocumento;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.consultar }, { title: this.titleConsultar, event: "" }];
  }
  setTitleEditarDocumento(data: any) {
    this.titleEditar = this.mantenimiento + ": " + " (Cod. " + data.user.ID + ")";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.consultarDocumento;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleEditar, event: "" }];
  }

  clearTitlebar() {
    this.titlebarComponent.iBack = false;
    this.titlebarComponent.iCancel = false;
    this.titlebarComponent.iClose = false;
    this.titlebarComponent.iEdit = false;
    this.titlebarComponent.msgEditar = "";
    this.titlebarComponent.msgTitle = [];
    this.titlebarComponent.eventBack = EVENTO.listar;
    this.titlebarComponent.eventCancel = EVENTO.listar;
    this.titlebarComponent.eventClose = "";
    this.titlebarComponent.eventEdit = EVENTO.listar;
  }

  changeEvent(evento: any) {
    this.evento = evento.evento;
    this.clearTitlebar();
    if (evento.data)
      this.data = evento.data;
    this.titlebarComponent.data = evento.data;

    switch (this.evento) {
      case EVENTO.listar:
        this.setTitleListar();
        break;
      case EVENTO.crear:
        this.setTitleInsertar(evento.data);
        break;
      case EVENTO.editar:
        this.setTitleEditar(evento.data);
        break;
      case EVENTO.consultar:
        this.setTitleConsultar(evento.data);
        break;
      case EVENTO.crearDocumento:
        this.setTitleInsertarDocumento(evento.data);
        break;
      case EVENTO.consultarDocumento:
        this.setTitleConsultarDocumento(evento.data);
        break;
      case EVENTO.editarDocumento:
        this.setTitleEditarDocumento(evento.data);
        break;
      default:
        break;
    }
  }
}
